/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '../../../../../base/api';
import { Area, City, Country } from '../../../../../base/interfaces/config';
import { SetFieldParams } from '../../../../../base/interfaces/params';
import { RecruiterType } from '../../../../enums';
import { SignUpStep } from '../../enums';

export interface Fields {
    email: string;
    password: string;
    phone: string;
    name: string;
    agreeTerms: boolean;
    recruiterType: RecruiterType;
    agencyName: string;
    city: City | null;
    countries: Country[];
    areas: Area[];
    emailCode?: string;
}

export interface SignUpState {
    step: SignUpStep;
    fields: Fields;
    errors: IError | null;
    shouldScrollToError: boolean;
}

const fieldsInitialState = {
    email: '',
    password: '',
    phone: '',
    name: '',
    agreeTerms: false,
    recruiterType: RecruiterType.Agency,
    agencyName: '',
    city: null,
    countries: [],
    areas: [],
};

const initialState: SignUpState = {
    step: SignUpStep.RegistrationInfo,
    fields: fieldsInitialState,
    errors: null,
    shouldScrollToError: false,
};

export const signUpSlice = createSlice({
    name: 'recruiter-app__signup',
    initialState,
    reducers: {
        clearData: (state) => {
            state.step = SignUpStep.RegistrationInfo;
            state.fields = fieldsInitialState;
            state.errors = null;
            state.shouldScrollToError = false;
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setSignUpStep: (state, action: PayloadAction<SignUpStep>) => {
            state.step = action.payload;
        },
        setField: (state, action: PayloadAction<SetFieldParams>) => {
            state.fields = {
                ...state.fields,
                [action.payload.id]: action.payload.value,
            };
            if (state.errors === null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.errorGroupName || action.payload.id]: removedError, ...errors } = state.errors;
            state.errors = errors;
        },
        setErrors: (state, action: PayloadAction<IError>) => {
            if (state.errors) {
                state.errors = {
                    ...state.errors,
                    ...action.payload,
                };
            } else {
                state.errors = action.payload;
            }
        },
        setShouldScrollToError: (state, action: PayloadAction<boolean>) => {
            state.shouldScrollToError = action.payload;
        },
        submitSignUp: () => {},
        submitChangeConfirmationValue: {
            reducer: () => {},
            prepare: (newEmail: string, recaptchaToken: string | null, callback: () => void) => ({
                payload: { newEmail, recaptchaToken, callback },
            }),
        },
    },
});

export const signUpActions = signUpSlice.actions;
export const signUpReducer = signUpSlice.reducer;
